import { render, staticRenderFns } from "./bannerTop.vue?vue&type=template&id=4f21b026&scoped=true&"
import script from "./bannerTop.vue?vue&type=script&lang=js&"
export * from "./bannerTop.vue?vue&type=script&lang=js&"
import style0 from "./bannerTop.vue?vue&type=style&index=0&id=4f21b026&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f21b026",
  null
  
)

export default component.exports